"use client";

import { useEffect } from "react";

import { useDebug } from "./useDebug";
import { useForm } from "./useForm";
import { useMaybeNavigationActionInterceptor } from "./useNavigationActionInterceptor";

/**
 * Registers a navigation interceptor while the surrounding Form is dirty.
 * When registered, the NavigationActionInterceptorProvider will show the
 * confirmation modal before allowing navigation to proceed.
 *
 * Called internally by `<Form trackDirty>` — consumers don't usually need
 * to call it directly.
 */
export const useFormNavigationGuard = (): void => {
  const form = useForm();
  const interceptor = useMaybeNavigationActionInterceptor();
  const { log } = useDebug();
  const isDirty = form?.isDirty ?? false;

  useEffect(() => {
    if (!interceptor || !isDirty) return;

    log(
      "orange",
      "useFormNavigationGuard",
      "Interceptor registered (form dirty)",
    );
    const unregister = interceptor.registerInterceptor(() => true);
    return () => {
      log("orange", "useFormNavigationGuard", "Interceptor unregistered");
      unregister();
    };
  }, [interceptor, isDirty, log]);
};
